import {Module} from "vuex";
import {RootState} from "@/store/types";
import {getters} from "@/store/modules/menus/menus-getters";
import {actions} from "@/store/modules/menus/menus-actions";
import {mutations} from "@/store/modules/menus/menus-mutations";
import { MenusState } from "./types";

export const state: MenusState = {
   test : 'hello',
   currentSidebarElement : 'Home'
};

export const menus: Module<MenusState, RootState> = {
    namespaced : true,
    state,
    getters,
    actions,
    mutations,
};